module.exports = __webpack_public_path__ + "static/media/loja-barigui.06647786.jpg";